import {
  CircularProgress,
  Stack,
  Backdrop,
  CircularProgressProps,
} from "@mui/material";
import React, { FC } from "react";

interface GlobalLoader {
  color?: CircularProgressProps["color"];
  size?: CircularProgressProps["size"];
  thickness?: CircularProgressProps["thickness"];
}

const GlobalLoader: FC<GlobalLoader> = ({ color, size, thickness }) => {
  return (
    <Backdrop
      open
      sx={(theme) => ({
        backgroundColor: theme.palette.common.white,
        zIndex: theme.zIndex.drawer + 1,
      })}
    >
      <Stack justifyContent="center" alignItems="center">
        <CircularProgress size={size} color={color} thickness={thickness} />
      </Stack>
    </Backdrop>
  );
};

export default GlobalLoader;
